(function () {
  if (window.__misLandingInitialized) return;
  window.__misLandingInitialized = true;
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const observers = [];
    const timers = [];
    const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: abort.signal });
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.classList.add('mis-js');
    try { if (sessionStorage.getItem('mis-country-selected') === 'yes') root.classList.add('mis-country-selected'); } catch {}
    root.querySelectorAll('.mis-pains, .mis-benefit-grid, .mis-stages, .mis-bonuses').forEach(group => {
      group.querySelectorAll('.mis-reveal').forEach((el, index) => el.style.transitionDelay = `${(index % 6) * 90}ms`);
    });
    if ('IntersectionObserver' in window && !reduce) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('is-pending'); observer.unobserve(entry.target); }
      }), { rootMargin: '0px 0px -4% 0px' });
      observers.push(observer);
      root.querySelectorAll('.mis-reveal').forEach(el => {
        if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('is-pending'); observer.observe(el); }
      });
    }
    const sticky = root.querySelector('.mis-sticky');
    const hero = root.querySelector('.mis-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      let heroVisible = true;
      const zones = new Set();
      const update = () => sticky.classList.toggle('is-visible', !heroVisible && zones.size === 0);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          else if (entry.isIntersecting) zones.add(entry.target);
          else zones.delete(entry.target);
        });
        update();
      });
      observers.push(observer);
      observer.observe(hero);
      root.querySelectorAll('[data-mis-hide-sticky]').forEach(el => observer.observe(el));
    }
    root.querySelectorAll('[data-mis-country]').forEach(select => {
      const form = select.form;
      const label = form.querySelector('label');
      const submit = form.querySelector('button[type="submit"]');
      const wrap = document.createElement('div');
      wrap.className = 'mis-country-search';
      const input = document.createElement('input');
      input.id = select.id + '-search';
      input.type = 'text';
      input.placeholder = 'Escribe tu país';
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      const list = document.createElement('div');
      list.id = input.id + '-results';
      list.className = 'mis-country-results';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Países disponibles');
      list.hidden = true;
      input.setAttribute('aria-controls', list.id);
      const status = document.createElement('span');
      status.id = input.id + '-status';
      status.className = 'mis-country-status';
      status.setAttribute('role', 'status');
      input.setAttribute('aria-describedby', status.id);
      const fold = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').trim();
      const countries = Array.from(select.options, option => ({ value: option.value, text: option.textContent.trim(), key: fold(option.textContent) }));
      let matches = [];
      let active = -1;
      let submitting = false;
      const close = () => {
        list.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
      };
      const choose = country => {
        if (!country || submitting) return;
        submitting = true;
        try { sessionStorage.setItem('mis-country-selected', 'yes'); } catch {}
        select.value = country.value;
        input.value = country.text;
        close();
        status.textContent = 'Actualizando precio y moneda…';
        form.requestSubmit();
      };
      const highlight = () => {
        Array.from(list.children).forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
        if (active >= 0) {
          input.setAttribute('aria-activedescendant', list.children[active].id);
          list.children[active].scrollIntoView({ block: 'nearest' });
        } else input.removeAttribute('aria-activedescendant');
      };
      const render = (allowEmpty = false) => {
        const query = fold(input.value);
        list.replaceChildren();
        matches = query || allowEmpty ? countries.filter(country => country.key.includes(query) || country.value.toLowerCase() === query) : [];
        active = -1;
        input.removeAttribute('aria-activedescendant');
        for (const [index, country] of matches.entries()) {
          const option = document.createElement('button');
          option.type = 'button';
          option.id = list.id + '-' + index;
          option.tabIndex = -1;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.textContent = country.text;
          on(option, 'mousedown', event => event.preventDefault());
          on(option, 'click', () => choose(country));
          list.append(option);
        }
        list.hidden = !matches.length;
        input.setAttribute('aria-expanded', String(matches.length > 0));
        status.textContent = query && !matches.length ? 'No encontramos ese país entre los destinos disponibles.' : query ? matches.length + ' resultado(s). Selecciona tu país.' : 'Escribe y selecciona tu país para actualizar el precio.';
      };
      on(input, 'input', () => render());
      on(input, 'focus', () => { if (input.value) render(); });
      on(input, 'blur', close);
      on(input, 'keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (list.hidden) render(true);
          if (!matches.length) return;
          active = event.key === 'ArrowDown' ? (active + 1) % matches.length : (active <= 0 ? matches.length - 1 : active - 1);
          highlight();
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (!list.hidden) choose(matches[active >= 0 ? active : matches.length === 1 ? 0 : -1]);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      });
      wrap.append(input, list);
      select.before(wrap);
      form.append(status);
      label.htmlFor = input.id;
      label.textContent = 'Escribe tu país';
      select.hidden = true;
      submit.hidden = true;
      render();
    });
    const demo = root.querySelector('[data-mis-calc-demo]');
    if (demo) {
      const quantity = demo.querySelector('input');
      const numbers = demo.querySelectorAll('[data-mis-amount]');
      const update = () => {
        const count = Number(quantity.value);
        if (!quantity.checkValidity() || !Number.isFinite(count)) return;
        numbers.forEach(el => el.textContent = new Intl.NumberFormat('es', { maximumFractionDigits: 2 }).format(Number(el.dataset.misAmount) * count / 2));
        demo.querySelector('[data-mis-portions]').textContent = count;
        demo.querySelector('[data-mis-demo-status]').textContent = '';
      };
      on(quantity, 'input', update);
      on(demo.querySelector('button'), 'click', () => {
        if (!quantity.reportValidity()) return;
        demo.querySelector('[data-mis-demo-status]').textContent = 'Así se ajustan las cantidades. En tu plataforma puedes sumarlas a la lista, copiarla o descargarla.';
      });
      update();
    }
    root.querySelectorAll('[data-mis-carousel]').forEach(carousel => {
      const track = carousel.querySelector('.mis-carousel-track');
      const pause = carousel.querySelector('[data-mis-pause]');
      let paused = reduce;
      let hovered = false;
      let focused = false;
      const step = direction => {
        const card = track.querySelector('.mis-testimonial');
        if (!card) return;
        const max = track.scrollWidth - track.clientWidth;
        const width = card.getBoundingClientRect().width + 20;
        let left = track.scrollLeft + width * direction;
        if (left > max + 5) left = 0;
        if (left < -5) left = max;
        track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: reduce ? 'auto' : 'smooth' });
      };
      const label = () => { pause.textContent = paused ? 'Reproducir' : 'Pausar'; pause.setAttribute('aria-label', paused ? 'Reproducir carrusel' : 'Pausar carrusel'); };
      label();
      on(pause, 'click', () => { paused = !paused; label(); });
      on(carousel.querySelector('[data-mis-prev]'), 'click', () => step(-1));
      on(carousel.querySelector('[data-mis-next]'), 'click', () => step(1));
      on(carousel, 'mouseenter', () => hovered = true);
      on(carousel, 'mouseleave', () => hovered = false);
      on(carousel, 'focusin', () => focused = true);
      on(carousel, 'focusout', event => focused = carousel.contains(event.relatedTarget));
      on(track, 'pointerdown', () => { paused = true; label(); });
      timers.push(setInterval(() => {
        const bounds = track.getBoundingClientRect();
        if (!paused && !hovered && !focused && !document.hidden && bounds.top < innerHeight && bounds.bottom > 0) step(1);
      }, 6000));
    });
    const countdown = root.querySelector('[data-mis-deadline]');
    if (countdown) {
      const raw = countdown.dataset.misDeadline;
      const end = Date.parse(raw);
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/.test(raw) && Number.isFinite(end)) {
        const tick = () => {
          const diff = end - Date.now();
          countdown.hidden = diff <= 0;
          if (diff <= 0) return;
          const seconds = Math.floor(diff / 1000);
          const days = Math.floor(seconds / 86400);
          const hh = String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0');
          const mm = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
          const ss = String(seconds % 60).padStart(2, '0');
          countdown.querySelector('output').textContent = `${days ? days + ' d · ' : ''}${hh}:${mm}:${ss}`;
          countdown.querySelector('[data-mis-deadline-label]').textContent = new Intl.DateTimeFormat('es', { dateStyle: 'medium', timeStyle: 'short' }).format(end);
        };
        tick(); timers.push(setInterval(tick, 1000));
      }
    }
    const notice = root.querySelector('.mis-live-notice');
    let lastNotice = 0;
    on(window, 'mis:verified-activity', event => {
      const data = event.detail;
      if (!notice || !data || Date.now() - lastNotice < 30000 || document.hidden) return;
      const timestamp = Date.parse(data.timestamp);
      if (!Number.isFinite(timestamp) || timestamp > Date.now() + 5000 || Date.now() - timestamp > 300000) return;
      if (data.type === 'purchase' && typeof data.country === 'string' && data.country.length <= 60) {
        notice.querySelector('strong').textContent = `Nueva compra desde ${data.country}`;
        notice.querySelector('span').textContent = 'Actividad reciente de la tienda';
      } else if (data.type === 'viewers' && Number.isInteger(data.count) && data.count > 0) {
        notice.querySelector('strong').textContent = `${data.count} ${data.count === 1 ? 'persona está' : 'personas están'} mirando esta página`;
        notice.querySelector('span').textContent = 'Actividad actual';
      } else return;
      notice.hidden = false;
      lastNotice = Date.now();
      timers.push(setTimeout(() => notice.hidden = true, 6000));
    });
    instances.set(root, () => { abort.abort(); observers.forEach(x => x.disconnect()); timers.forEach(x => { clearInterval(x); clearTimeout(x); }); root.querySelectorAll('.is-pending').forEach(x => x.classList.remove('is-pending')); });
  }
  document.querySelectorAll('.mis').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.mis').forEach(initialize));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.mis').forEach(root => { instances.get(root)?.(); instances.delete(root); }));
})();
